import "../../layouts/Auth.css";

function UserDetails() {
  return (
    <main className="auth-page">
      <section className="auth-card">
        <h1 className="auth-title">Hello User</h1>
        <p className="auth-subtitle">Your profile details will appear here.</p>
      </section>
    </main>
  );
}

export default UserDetails;